<template>
  <div>
    <div class="rich-input">
      <input class="rich-input-field"
             :placeholder="placeholder"
             :value="inputValue"
             type="text"
             @input="changeHandle($event.target)">
    </div>
  </div>
</template>
<script>
  import { WordsParse } from '@/common/utils/wordsParse'
  export default {
    name: 'CPFInput',
    props: {
      value: {
        type: String,
        default: ''
      },
      numType: {
        type: String,
        default: 'CPF'
      },
      placeholder: {
        type: String
      }
    },
    data () {
      return {
        inputValue: this.value
      }
    },
    mounted () {
    },
    computed: {
    },
    methods: {
      changeHandle (target) {
        let value = target.value
        let newStr = WordsParse.parse(value).replace(new RegExp('ｰ', 'gm'), '-')
        target.value = newStr
        this.inputValue = newStr
        this.$emit('input', this.inputValue)
      }
    }
  }
</script>
<style lang="stylus" scoped>

</style>